// extracted by mini-css-extract-plugin
module.exports = {"box":"_1WEsJav2h2rMF-VdXZILvg","boxBtnClose":"_2_Cnh19qo1Bqy-0s5cZqmP","btnClose":"_1f7l5dO6EQwawfExUm6Oq0"};